import axios from 'axios';
import { TemperatureData } from '../types/types';

const API_KEY = "eyJvcmciOiI1ZTU1NGUxOTI3NGE5NjAwMDEyYTNlYjEiLCJpZCI6IjZmNjIyYzgwNzM1YjRkOTU5YTE5NTI1ZDhmYjZiOTA2IiwiaCI6Im11cm11cjEyOCJ9";
// Wijzig deze regel in src/services/api.ts
const BASE_URL = "https://knmi.verbaarschot.synology.me/api"; // IP van je KNMI API proxy server

// Define interfaces for the API response
interface TemperatureResponse {
    type: string;
    domain: {
        axes: {
            t: {
                values: string[];
            };
        };
    };
    ranges: {
        t_dryb_10: {
            values: number[];
        };
    };
    parameters: {
        t_dryb_10: {
            unit: {
                symbol: {
                    value: string;
                };
            };
        };
    };
}

interface Temperature {
    timestamp: string;
    value: number;
    unit: string;
}

export const fetchTemperature = async (
    stationCoords: { lat: number; lon: number },
    stationName: string
): Promise<Temperature[] | null> => {
    // Create time window (30 minutes ago until now)
    const now = new Date();
    const thirtyMinutesAgo = new Date(now.getTime() - 30 * 60 * 1000);
    const timeWindow = `${thirtyMinutesAgo.toISOString()}/${now.toISOString()}`;

    try {
        const response = await axios.get(`${BASE_URL}/temperature`, {
            params: {
                coords: `POINT(${stationCoords.lon} ${stationCoords.lat})`,
                datetime: timeWindow,
                "parameter-name": "t_dryb_10"
            }
        });

        console.log('Successful response:', response.data);

        // Extract and format the temperature data
        const times = response.data.domain.axes.t.values;
        const temperatures = response.data.ranges.t_dryb_10.values;
        const unit = response.data.parameters.t_dryb_10.unit.symbol.value;

        // Combine timestamps and temperatures
        return times.map((time: string, index: number) => ({
            timestamp: time,
            value: temperatures[index],
            unit
        }));

    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error('Gedetailleerde error:', {
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data,
                headers: error.response?.headers,
                config: {
                    url: error.config?.url,
                    params: error.config?.params,
                    headers: error.config?.headers
                }
            });
        } else {
            console.error('Onverwachte error:', error);
        }
        return null;
    }
};

// Example usage with station coordinates
export const KNMI_STATIONS = {
    SCHIPHOL: { name: 'Schiphol Airport', lat: 52.3172, lon: 4.7897 },
    DE_BILT: { name: 'De Bilt', lat: 52.0989, lon: 5.1797 },
    ROTTERDAM: { name: 'Rotterdam Airport', lat: 51.9606, lon: 4.4469 }
};

// Helper function to convert UTC to local Dutch time
export const convertToLocalTime = (utcTimeString: string): string => {
    const date = new Date(utcTimeString);
    return date.toLocaleTimeString('nl-NL', {
        timeZone: 'Europe/Amsterdam',
        hour: '2-digit',
        minute: '2-digit'
    });
};

// Usage example:
/*
const getTemperatureForStation = async () => {
    const temps = await fetchTemperature(
        KNMI_STATIONS.DE_BILT,
        KNMI_STATIONS.DE_BILT.name
    );

    if (temps) {
        temps.forEach(temp => {
            console.log(
                `${convertToLocalTime(temp.timestamp)}: ${temp.value}${temp.unit}`
            );
        });
    }
};
*/